import { render } from "./MemberItem.vue?vue&type=template&id=490d348a&ts=true"
import script from "./MemberItem.vue?vue&type=script&lang=ts"
export * from "./MemberItem.vue?vue&type=script&lang=ts"

import "./MemberItem.vue?vue&type=style&index=0&id=490d348a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__